import { useMemo } from 'react'

import { YStack } from '@zet/design-system/layout'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { Benefits } from '@zet/feature-brands/components/benefits'

import useVariantDetails from '../../hooks/useVariantDetails'

const BrandBenifitsContent = ({
  brandId,
  isFixedHeight,
  variantId,
}: {
  brandId: string | number
  isFixedHeight?: boolean
  variantId?: string | number
}) => {
  const { data: content } = useBrandDetailsById(brandId)
  const { data: variantData } = useVariantDetails({
    variantId,
  })
  const benefits = useMemo(
    () =>
      (variantData?.detailedBenefits || content?.brandBenefits)?.map(
        (element: object, index: number) => {
          return {
            id: index,
            icon: '',
            heading: element?.heading,
            content: element?.subText,
          }
        }
      ),
    [content, variantData?.topBenefitsBrandDetail]
  )
  return (
    <YStack style={isFixedHeight ? { marginBottom: 40 } : {}}>
      {benefits?.map((benefit, index) => (
        <Benefits {...benefit} key={index} />
      ))}
    </YStack>
  )
}

export default BrandBenifitsContent
